<template>
    <el-row type="flex" class="row-bg" justify="center">
        <el-col :xl="6" :lg="7">
            <h2>欢迎来到黄冈预约服务官网</h2>
            <el-image
                    :src="require('@/assets/bg.png')"
                    style="height: 250px"
            ></el-image>
        </el-col>
        <el-col :span="1">
            <el-divider direction="vertical"></el-divider>
        </el-col>
        <el-col :xl="6" :lg="7">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- 登录 -->
                <el-tab-pane label="登录" name="first">
                    <el-form
                            :model="loginForm"
                            :rules="rules"
                            ref="loginForm"
                            label-width="100px"
                            class="demo-loginForm"
                    >
                        <el-form-item label="用户名" prop="username" style="width: 380px">
                            <el-input v-model="loginForm.username"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password" style="width: 380px">
                            <el-input v-model="loginForm.password" type="password"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="code" style="width: 380px">
                            <el-input
                                    v-model="loginForm.code"
                                    style="width: 53.8%; float: left"
                            ></el-input>
                            <el-image
                                    :src="captchaImg"
                                    class="captchaImg"
                                    @click="getCaptcha"
                            ></el-image>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="jump()">官网首页</el-button>
                            <el-button type="primary" @click="submitForm('loginForm')"
                            >登录</el-button
                            >
                            <el-button @click="resetForm('loginForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- 注册tab -->
                <el-tab-pane label="注册" name="second"
                ><el-form
                        :model="loginForm"
                        :rules="rules"
                        ref="loginForm"
                        label-width="100px"
                        class="demo-loginForm"
                >
                    <el-form-item label="用户名" prop="username" style="width: 380px">
                        <el-input v-model="loginForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="password" style="width: 380px">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="password" style="width: 380px">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" style="width: 380px">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="password" style="width: 380px">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code" style="width: 380px">
                        <el-input
                                v-model="loginForm.code"
                                style="width: 53.8%; float: left"
                        ></el-input>
                        <el-image
                                :src="captchaImg"
                                class="captchaImg"
                                @click="getCaptcha"
                        ></el-image>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('loginForm')"
                        >注册</el-button
                        >
                        <el-button @click="resetForm('loginForm')">重置</el-button>
                    </el-form-item>
                </el-form></el-tab-pane
                >
            </el-tabs>
        </el-col>
    </el-row>
</template>

<script>
    import qs from "qs";

    export default {
        name: "Login",
        data() {
            return {
                loginForm: {
                    username: "admin",
                    password: "111111",
                    code: "11111",
                },
                rules: {
                    username: [
                        { required: true, message: "请输入用户名", trigger: "blur" },
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                        { min: 5, max: 18, message: "长度为5到18个字符", trigger: "blur" },
                    ],
                    code: [
                        { required: true, message: "请输入验证码", trigger: "blur" },
                        { min: 5, max: 5, message: "长度为5个字符", trigger: "blur" },
                    ],
                },
                captchaImg: null,
                activeName: "first",
            };
        },
        mounted: function () {
            if(typeof this.$route.params.activeName == 'undefined'){
                this.activeName = 'first'
            }else{
                this.activeName = this.$route.params.activeName;
            }

        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios
                            .post("/login?" + qs.stringify(this.loginForm))
                            .then((res) => {

                                const jwt = res.headers["authorization"];

                                this.$store.commit("SET_TOKEN", jwt);
                                //   this.$router.push("/index");
                                this.$router.push({
                                    path:"/website",
                                    name:"website",
                                    params:{
                                        username:'张三'
                                    }
                                });
                            });
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getCaptcha() {
                this.$axios.get("/captcha").then((res) => {

                    this.loginForm.token = res.data.data.token;
                    this.captchaImg = res.data.data.captchaImg;
                    this.loginForm.code = "";
                });
            },
            jump() {
                this.$router.push('/website');
            },
            handleClick(tab, event) {

            },
        },
        created() {
            this.getCaptcha();
        },
    };
</script>

<style scoped>
    .el-row {
        background-color: #fafafa;
        height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
    }
    .el-divider {
        height: 200px;
    }
    .captchaImg {
        float: left;
        margin-left: 8px;
        border-radius: 4px;
    }
</style>
